import { render, staticRenderFns } from "./orderStatistics.vue?vue&type=template&id=4ed2a5d8&scoped=true&"
import script from "./orderStatistics.vue?vue&type=script&lang=js&"
export * from "./orderStatistics.vue?vue&type=script&lang=js&"
import style0 from "./orderStatistics.vue?vue&type=style&index=0&id=4ed2a5d8&lang=less&scoped=true&"
import style1 from "./orderStatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed2a5d8",
  null
  
)

export default component.exports